import { api } from '@/utils/api';
import { saveTrackIdToStorage } from '@/utils/utils';
import { SignUpCodeInput, TSignUpApiRequestAction } from '@verifime/components';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import SignUpView from './SignUpView';
import { ClientLogoByOrganisationCode } from '@verifime/views';

export default function SignUpBySignUpCodeView() {
  const [signUpCode, setSignUpCode] = useState<string>('');
  const [codeFromUrl, setCodeFromUrl] = useState<boolean>(false);

  const router = useRouter();
  const signUpCodeFromQuery = router.query.signUpCode as string;

  useEffect(() => {
    if (!signUpCodeFromQuery) {
      return;
    }
    setCodeFromUrl(true);
    setSignUpCode(signUpCodeFromQuery);
  }, [signUpCodeFromQuery]);

  const signUpApiRequest: TSignUpApiRequestAction = async (email) => {
    try {
      const trackingReferenceResponse = await api.postV1userselfsignuptracking({
        email,
        code: signUpCode,
      });
      const isNewCustomer = trackingReferenceResponse.invitationSent === true;

      if (isNewCustomer) {
        return Promise.resolve('MAGIC_LINK');
      }

      const trackId = trackingReferenceResponse.trackingReference;
      saveTrackIdToStorage(trackId);
      router.push(`/?lastAuthEmail=${encodeURIComponent(email)}`);
    } catch {
      return Promise.resolve('ERROR');
    }
  };

  return (
    <SignUpView
      signUpApiRequestAction={signUpApiRequest}
      renderExtraEnterEmailChildren={({ setError }) => (
        <>
          <SignUpCodeInput
            initalSignUpCode={signUpCode}
            onSignUpCodeChange={(signUpCode) => {
              setSignUpCode(signUpCode);
              setError('');
            }}
            isDisabled={codeFromUrl}
          />
          <ClientLogoByOrganisationCode organisationCode={signUpCode} />
        </>
      )}
    ></SignUpView>
  );
}
